export const RESEND_INVITATION = 'RESEND_INVITATION'
export const RESEND_INVITATION_SUCCESS = 'RESEND_INVITATION_SUCCESS'
export const RESEND_INVITATION_FAILED = 'RESEND_INVITATION_FAILED'
